import { Component, OnInit } from '@angular/core'
import { ComplaintService } from './complaint.service'
import { ConfigProvider } from './config.service'

@Component({
  selector: 'app-root',
  templateUrl: './complaint.component.html',
  styleUrls: ['./complaint.component.scss']
})
export class ComplaintComponent implements OnInit {
  config: any
  complaintId: number
  complaintSent = false

  constructor(public complaintService: ComplaintService, configProvider: ConfigProvider) {
    this.config = configProvider.getConfig()
  }

  app = {
    applicantType: 1,
    fullName: '',
    personalNumber: '',
    legalFirmName: '',
    legalFirmIdNumber: '',
    phoneNumber: '',
    otherPhoneNumber: '',
    address: '',
    email: '',
    policyApplicationNumber: '',
    description: '',
    receivalType: 1,
    recaptcha: null
  }

  switchApplicantType(type: number): void {
    this.app.applicantType = type
  }

  switchReceivalType(type: number): void {
    this.app.receivalType = type
  }

  sendRequest(): void {
    this.complaintService.registerComplaint(this.app).subscribe(
      (data) => {
        this.complaintSent = true
      },
      (err) => {
        console.log(err)
      }
    )
  }

  ngOnInit(): void {
    this.complaintService.getAuthToken().subscribe(data => {
    });
    document.title = this.config.APP_TITLE
  }
}
